const svgPlayButton = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="#000" d="M18.583 10.541c1.193.607 1.193 2.311 0 2.918L8.49 18.586c-1.089.553-2.378-.238-2.378-1.459V6.873c0-1.221 1.29-2.012 2.378-1.46l10.092 5.128z"/>
  </svg>
`;

var ProductController = {
  init: function(props) {
    this.props = Object.freeze(props);
    this.state = {
      variant: props.variant
    };

    const addToCartMarker = $('.js-atc-visibilty-marker')[0];
    // this.observer.observe(addToCartMarker);
    
    this.setupEventListeners();

    if($('#product-selectors').length > 0){
      new Shopify.OptionSelectors('product-selectors', {
        product: this.props.product,
        onVariantSelected: this.handleVariantSelected.bind(this),
        enableHistoryState: true
      });
    }

    Shopify.linkOptionSelectors({
      product: this.props.product, 
      variantsMetafields: this.props.variantsMetafields,
      wrapperSelector: '.product',
      isSalePage: this.props.is_sale_page
    });

    if($(".swatch-element.color").length) {
      this.handleColorSelect($('.swatch-element.color input[name="option-0"]:checked'));
    } else {
      this.loadMedia();
    }

    return this;
  },

  observer: new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      const addToCartContainer = $('.js-atc-wrapper');

      if(entry.isIntersecting) {
        addToCartContainer.addClass('sticky-atc-button');
      } else {
        if(entry.boundingClientRect.top > 0) {
          addToCartContainer.removeClass('sticky-atc-button');
        }
      }
    })
  }),

  getTouchClientX: function($evt) {
    var evt = $evt.originalEvent;
    if(evt && evt.changedTouches && evt.changedTouches.length) {
      return evt.changedTouches[0].clientX;
    }
  },

  handleColorSelect: function($el) {
    this.loadMedia($el.data('value'));
    $(".js-color-active").text($el.val());
  },

  handleDetailsToggle: function(evt) {
    evt.preventDefault();
    var $contentWrappers = $("[data-has-collapse] .js-toggle");
    $contentWrappers.not(this).removeClass('open').next().slideUp();
    $(this).toggleClass("open").next().slideToggle();
  },

  handleMediaNext: function() {
    var nextIndex = this.state.variantMediaIndex + 1;
    if(nextIndex > (this.state.variantMedia.length - 1)) {
      nextIndex = 0;
    }
    this.selectThumbnail(nextIndex);
  },

  handleMediaPrevious: function() {
    var nextIndex = this.state.variantMediaIndex - 1;
    if(nextIndex < 0) {
      nextIndex = this.state.variantMedia.length - 1;
    }
    this.selectThumbnail(nextIndex);
  },

  handleQuantityChange: function(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    var self = $(this),
      input = $('.product__quantity input[name="quantity"]'),
      oldVal = parseInt(input.val()),
      newVal = 1;
    switch (true) {
      case (self.hasClass('plus')): {
        newVal = oldVal + 1;
        break;
      }
      case (self.hasClass('minus') && oldVal > 1): {
        newVal = oldVal - 1;
        break;
      }
    }
    input.val(newVal).trigger('change');
  },

  handleThumbnailClick: function(evt) {
    var el = evt.currentTarget;
    if(el) {
      var index = parseInt(el.dataset['index']);
      if(!isNaN(index)) {
        this.selectThumbnail(index);
      }
    }
  },

  handleTouchEnd: function(evt) {
    var swipeThreshold = 30;
    if(this.state.touchX !== undefined) {
      var newX = this.getTouchClientX(evt);
      var distanceX = newX - this.state.touchX;
      var directionX = Math.sign(distanceX);
      var absDistanceX = Math.abs(distanceX);
      if(absDistanceX > swipeThreshold) {
        if(directionX > 0) {
          this.handleMediaPrevious();
        } else {
          this.handleMediaNext();
        }
      }
    }
    this.state.touchX = undefined;
  },

  handleTouchStart: function(evt) {
    this.state.touchX = this.getTouchClientX(evt);
  },

  handleVariantSelected: function(variant, selector) {
    var event = new CustomEvent('variant_change', { 
      detail: {
        variant
      }
    });
    document.dispatchEvent(event);

    this.state.variant = variant;
    
    var bisbtnWrapper   = $('.js-back-in-stock'),
        addToCartBtn    = $('#product-add-to-cart'),
        $productPrice    = $('.product .price'),
        $comparePrice    = $('.product .compare-price'),
        $originalPriceHidden = $("input[name='price-original']"),
        $hasSaleVariants = $('.js-product-has-sale-variants'),
        $isSaleVariant = $('.js-product-is-sale-variant'),
        $badge = $('.js-product-badge'),
        swatchSizeSoldout = $('.swatch[data-option-index="1"]').find('.swatch-element.sizes.soldout input.sizes'),
        $percentOffDisplay = $('.percent-off'),
        $inventoryMessage = $('.js-inventory-message'),
        $inventoryCount = $('.js-inventory-count');

    if(variant) {
      if (variant.available) {
        addToCartBtn.removeClass('disabled').prop('disabled', false).val(window.inventory_text.add_to_cart);
        bisbtnWrapper.hide();
      } else {
        //  Hide the Add to cart buttons and
        //  trigger BIS button if variant is OOS
        addToCartBtn.val(window.inventory_text.sold_out).addClass('disabled').attr('disabled', 'disabled');
        bisbtnWrapper.fadeIn();
      };

      const isLowInventory = variant.inventory_quantity <= 10 && variant.inventory_quantity > 0;

      if (isLowInventory) {
        $inventoryMessage.show();
        $inventoryCount.html(variant.inventory_quantity);
      } else {
        $inventoryMessage.hide();
      };

      const displayPrice = variant.price * this.props.sitewideSaleMultiplier;
      const comparePrice = variant.compare_at_price || variant.price;
      $productPrice.html(window.formatMoney(displayPrice));

      var isOnSale = comparePrice > displayPrice;
      var isMarkedDown = comparePrice > variant.price;
      if(isOnSale) {
        $comparePrice.html(window.formatMoney(comparePrice)).show();
        $originalPriceHidden.val(comparePrice);
        const percentOff = Math.floor((comparePrice - displayPrice) / comparePrice * 100);
        $percentOffDisplay.html(`(${percentOff}% off)`).show();
      } else {
        $comparePrice.hide();
        $originalPriceHidden.val('');
        $percentOffDisplay.hide();
      }

      if(isMarkedDown) {
        $isSaleVariant.show();
        $hasSaleVariants.hide();
      } else {
        $hasSaleVariants.show();
        $isSaleVariant.hide();
      }

      this.updateBadge();

      var form = $('#' + selector.domIdPrefix).closest('form');

      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');

        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    } else {
      //Hide the Add to cart buttons and
      //trigger BIS button if variant is OOS
      addToCartBtn.val(window.inventory_text.sold_out).addClass('disabled').attr('disabled', 'disabled');
      $bisbtnWrapper.fadeIn();

      //change Prices if Soldout sizes are clicked
      var swatchSizeLabel = $('.swatch[data-option-index="1"]').find('.swatch-element.sizes label'),
      swatchSizeSoldOutLabel = $('.swatch[data-option-index="1"]').find('.swatch-element.sizes.available.soldout label'),
      swatchSizeSoldout = $('.swatch[data-option-index="1"]').find('.swatch-element.sizes.available.soldout input.sizes');

      swatchSizeSoldOutLabel.on('click', function() { 
        soldOutPrice    = $(this).closest('label').data().price,
        variantID     = $(this).closest('label').attr('data-variant-id');  

        //change the Soldout variants price
        $productPrice.html(window.formatMoney(soldOutPrice));

      });

      //for Duvet products 
      swatchSizeLabel.on('click',function(){ 
        soldOutPrice    = $(this).closest('label').data().price;
        $productPrice.html(window.formatMoney(soldOutPrice));
      });
    }
  },

  loadMedia: function(filterKey) {
    var $dots = $('.js-product-dots').empty();
    var $thumbnails = $('.js-product-thumbnails').empty();
    this.state.variantMedia = this.props.productMedia.filter(img => !filterKey || img.key === filterKey);
    this.state.variantMediaIndex = undefined;
    this.state.variantMedia.forEach((img, index) => {
      let playIcon = "";

      if(img.mediaType === "video") {
          playIcon = `
            <div class="product__thumbnail-play-icon">
              ${svgPlayButton}
            </div>
          `;
      }

      $thumbnails.append(`
        <div
          class="product__thumbnail ${img.key} js-product-thumbnail"
          data-tracking-click
          data-event-action="Thumbnail Click"
          data-event-label="Image ${index + 1}"
          data-index="${index}"
        >
          <img src="${img.compactUrl}" alt="${img.alt}" />
          ${playIcon}
        </div>
      `);

      $dots.append(`
        <div
          class="product__photos-dot js-product-dot"
          data-tracking-click
          data-event-action="Image Dot Click"
          data-event-label="Image ${index + 1}"
          data-index="${index}"
        ></div>
      `);
    });
    this.selectThumbnail(0);
    
    $(".js-click-hover").on("click", function(evt) {
      evt.stopPropagation();
      $(this).toggleClass("hover");
    });
  },

  selectThumbnail: function(index) {
    if(index === this.state.variantMediaIndex) {
      return;
    }

    var media = this.state.variantMedia[index];
    if(!media) {
      return;
    }

    this.state.variantMediaIndex = index;

    $(".js-product-thumbnail").removeClass("active");
    $(`.js-product-thumbnail[data-index="${index}"]`).addClass("active");
    $(".js-product-dot").removeClass("active");
    $(`.js-product-dot[data-index="${index}"]`).addClass("active");

    $(".js-photo-current").removeClass("js-photo-current").addClass("js-photo-previous");

    this.updateBadge();

    function onMediaLoad() {
      const currentMediaTypeTag = (media.mediaType == "image") ? "img" : "video";

      $(`.js-photo-current ${currentMediaTypeTag}`).animate({opacity: 1}, function(){
        $(".js-photo-previous").remove();
        });
      };

      $(".js-product-photo").append(`
        <div class="product__photo js-photo-current js-swipable" id="variant-img-${index + 1}">
        </div>
      `);

    var $current = $(".js-photo-current");

    if (media.mediaType == "image"){
      const img = new Image();
      img.onload = onMediaLoad;
      img.alt = media.alt;
      img.src = media.mainUrl;
      img.style="opacity: 0;";
      $current.append(img);
    } else if (media.mediaType == "video"){
      const video = $(media.videoTag);
      video.css("opacity", "0");
      $current.append(video);
      onMediaLoad();
      $("body").trigger("tracking_event", {
        category: "Product",
        action: "Video Loaded",
        label: this.props.product.title
      });
    }
  },

  setupEventListeners: function() {
    var $body = $('body');
    var self = this;
    $body.on('click.dot', '.js-product-dot', this.handleThumbnailClick.bind(this));
    $body.on('click.imageNext', '.js-product-photo-next', this.handleMediaNext.bind(this));
    $body.on('click.imagePrevious', '.js-product-photo-previous', this.handleMediaPrevious.bind(this));
    $body.on('click.thumbnail', '.js-product-thumbnail', this.handleThumbnailClick.bind(this));
    $body.on('click.toggle', '[data-has-collapse] .js-toggle', this.handleDetailsToggle);
    $body.on('click.quantity', '.js-product-quantity', this.handleQuantityChange);
    $body.on('touchstart.swipe', '.js-swipable', this.handleTouchStart.bind(this));
    $body.on('touchend.swipe', this.handleTouchEnd.bind(this));
    $('.swatch-element.color input[type="radio"]').on('click', function(){
      self.handleColorSelect($(this));
    });
  },

  updateBadge: function() {
    var $el = $('.js-product-badge');
    var isOnSale = this.state.variant && this.state.variant.compare_at_price > this.state.variant.price;
    if(this.state.variantMediaIndex !== 0 || isOnSale) {
      $el.hide();
    } else {
      $el.fadeIn();
    }
  }
};

$(function() {
  window.productController = Object.create(ProductController); 
  window.productController.init(PageProps);
});
